import Vue from 'vue'
import KeyboardOption from './keyboard'

export const $numberKeyboard = defaultValue => {
  return new Promise((resolve, reject) => {
    const NumberKeyboard = Vue.extend(KeyboardOption)
    const component = new NumberKeyboard({
      propsData: {
        defaultValue
      }
    }).$mount()
    component.$on('confirm', resolve)
    component.$on('close', reject)
    document.body.appendChild(component.$el)
  })
}
